import React, { useState, useEffect } from "react";
import { Col, Row, Badge, Modal, ModalBody, Spinner, Button, Alert } from "reactstrap";
import "./modal.css";
import { Link } from "react-router-dom";
import { disbursementService } from "../../../services/disbursement.service";
import { permissionsConstants } from "../../../../../constants/permission.constants";
import AccessControl from "../../../../../shared/components/AccessControl";
import { MdVerticalAlignBottom } from "react-icons/md";
const { EDIT_DISBURSEMENT, ACTIONS_DISBURSEMENT, VIEW_DISBURSEMENT } = permissionsConstants;

const DisbursementModal = (props) => {
    const { id, visible, onClose, reviewDisbursement, loader } = props;
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [comment, setComment] = useState("")
    const [error, setError] = useState(null);
    const [openWarning, setOpenWarning] = useState(false);

    useEffect(() => {
        let mounted = true;
        if(id && mounted) {
            fetchDisbursement("with loader");
        }
        return () => {
            mounted = false;
            setComment("");
            setOpenWarning(false);
        }
    }, [id]);

    const loadReviewDisbursement = id => {
        if(comment.length) {
            return reviewDisbursement(id, comment)
        }
        setOpenWarning(true);
    };
    const handleChange = e => {
        const text = e.target.value;
        setComment(e.target.value);
        if(text && text.length){
            setOpenWarning(false);
        }
    };

    const fetchDisbursement = async (condition) => {
        if (condition && condition === "with loader") {
            setLoading(true);
        }
        setLoading(true);
        setError(null);
        try {
            const response = await disbursementService.getDisbursementById(id);
            if (response) {
                setData(response);
                setError(null);
                setLoading(false);
            }
        } catch (error) {
            if (error && error.data) {
                return setError(error.data);
            }
            setError({ message: "Could not fetch disbursement details" });
        }
    };

    return (
        <Modal isOpen={visible} centered={true} size="lg" backdrop={true}>
            <ModalBody style={{ margin: 12 }}>
                {
                    error ? (
                        <>
                            <Row>
                                <Col xs="auto">
                                    <span className="page-title bold-text" style={{ fontSize: 17 }}></span>
                                </Col>
                                <Col style={{ textAlign: "right", fontSize: 19, cursor: "pointer" }} onClick={() => onClose(false)}>
                                    <strong>x</strong>
                                </Col>
                            </Row>
                            <Row className="text-center">
                                <div style={{ margin: "0 auto" }}>
                                    <h4 className="text-danger">{!error.message || !error.description ? `Something went wrong. Could not fetch disbursement with id - ${id}` : error.message || error.description}</h4>
                                    <Button color="primary" id="btn-try-again" outline size="sm" onClick={fetchDisbursement}>
                                        Try Again
                                    </Button>
                                </div>
                            </Row>
                        </>
                    ) : (
                        <>
                            {
                                loading ? (
                                    <Row className="text-center">
                                        <div style={{ margin: "0 auto" }}>
                                            <Spinner color="success" className="my-4" style={{ width: "6rem", height: "6rem" }} />
                                            <h4 className="text-secondary">{`Fetching disbursement with id - ${id}`}</h4>
                                        </div>
                                    </Row>
                                ) : (
                                    <>
                                        {data ? (
                                            <>
                                                <Row>
                                                    <Col xs="auto">
                                                        <span className="page-title bold-text" style={{ fontSize: 17 }}>{`Batch Name: ${data?.batchName}`}</span>
                                                    </Col>
                                                    <Col style={{ textAlign: "right", fontSize: 19, cursor: "pointer" }} onClick={() => onClose(false)}>
                                                        <strong>x</strong>
                                                    </Col>
                                                </Row>
                                                <br />
                                                <Row>
                                                    <Col className="bold-text">Disbursement Details</Col>
                                                </Row>
                                                <br />
                                                <Row>
                                                    <Col>
                                                        <b>No of Recipient</b>
                                                    </Col>
                                                    <Col>
                                                        <b>Created By</b>
                                                    </Col>
                                                    <Col>
                                                        <b>Creation Date</b>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>{data?.numberOfRecipients || "N/A"}</Col>
                                                    <Col>{data?.createdBy || "N/A"}</Col>
                                                    <Col>{data?.createdOn || "N/A"}</Col>
                                                </Row>
                                                <hr />
                                                <Row>
                                                    <Col>
                                                        <b>Reviewed By</b>
                                                    </Col>
                                                    <Col>
                                                        <b>Review Date</b>
                                                    </Col>
                                                    <Col>
                                                        <b>Scheduled Date</b>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>{data?.reviewedBy || "N/A"}</Col>
                                                    <Col>{data?.reviewedOn || "N/A"}</Col>
                                                    <Col>{data?.scheduledDisbursementTime || "N/A"}</Col>
                                                </Row>

                                                {data?.status === "approved" && (
                                                    <>
                                                        <AccessControl allowedPermissions={[VIEW_DISBURSEMENT]} renderNoAccess={() => null}>
                                                            <hr />
                                                            <Row>
                                                                <Col>
                                                                    <strong>Actions</strong>
                                                                </Col>
                                                                <Col></Col>
                                                                <Col style={{ alignItems: "right" }}>
                                                                    <Link to={`/disbursement/recipient/${id}`}>
                                                                        <Badge color="warning" className="actionButton">
                                                                            View Recipient List
                                                                        </Badge>
                                                                    </Link>
                                                                </Col>
                                                            </Row>
                                                        </AccessControl>
                                                    </>
                                                )}
                                                {data?.status === "redraft" &&
                                                    <AccessControl allowedPermissions={[EDIT_DISBURSEMENT]} renderNoAccess={() => null}>
                                                        <hr />
                                                        <Row>
                                                            <Col>
                                                                <strong>Actions</strong>
                                                            </Col>
                                                            <Col></Col>
                                                            <Col style={{ alignItems: "right" }}>
                                                                <Link to={`/disbursement/edit/${id}`}>
                                                                    <Badge color="warning" className="actionButton">
                                                                        Edit
                                                                    </Badge>
                                                                </Link>
                                                            </Col>
                                                        </Row>
                                                    </AccessControl>
                                                }
                                                
                                                { data?.status === 'pending_review' &&
                                                    <AccessControl allowedPermissions={[ACTIONS_DISBURSEMENT]} renderNoAccess={() => null}>
                                                        <hr />
                                                        <Row className="mb-2">
                                                            <Col><strong>Review Disbursement</strong></Col>
                                                        </Row>
                                                        {data?.fileUrl &&
                                                        <Row className="mb-1">
                                                            <Col>
                                                                <a
                                                                    target="blank"
                                                                    href={data.fileUrl}
                                                                >
                                                                    
                                                                    Download File Attached <MdVerticalAlignBottom />
                                                                </a>
                                                            </Col>
                                                        
                                                        </Row>}
                                                        <Row>
                                                            <Col lg={12} md={12} sm={12}>
                                                                <textarea 
                                                                    rows={5} 
                                                                    col={12} 
                                                                    name="comment" 
                                                                    placeholder="Reviewer's comment(s)" 
                                                                    value={comment} 
                                                                    onChange={handleChange} 
                                                                    style={{width: "100%"}}
                                                                    className="mb-2"
                                                                />
                                                            </Col>
                                                        </Row>
                                                        {
                                                            openWarning &&
                                                            <Row>
                                                                <Col lg={12} md={12} sm={12}>
                                                                    <Alert color="danger">
                                                                        A comment is required for any disbursement review action
                                                                    </Alert>
                                                                </Col>
                                                            </Row>
                                                        }
                                                        <Row>
                                                            <Col lg={2} md={2} sm={2}>
                                                                <Badge color="success" className="actionButton" onClick={()=>loadReviewDisbursement(1)}>
                                                                    {
                                                                        loader === 1 ? <Spinner size="sm" color="default" /> : "Approve"
                                                                    }
                                                                </Badge>
                                                            </Col>
                                                            <Col lg={2} md={2} sm={2}>
                                                                <Badge color="danger" className="actionButton" onClick={()=>loadReviewDisbursement(2)}>
                                                                { loader === 2 ? <Spinner size="sm" color="default" /> : "Reject" }
                                                                </Badge>
                                                            </Col>
                                                            <Col lg={2} md={2} sm={2}>
                                                                <Badge color="warning" className="actionButton" onClick={()=>loadReviewDisbursement(3)}>
                                                                { loader === 3 ? <Spinner size="sm" color="default" /> : "Redraft" }
                                                                </Badge>
                                                            </Col>
                                                        </Row> 
                                                        
                                                        
                                                    </AccessControl>
                                                }
                                                    <hr />
                                                {
                                                    (data?.remark || data?.reviewerComment) &&
                                                        <>
                                                            <Row>
                                                                <Col><strong>Admin Comment</strong></Col>
                                                            </Row>
                                                            <Row>
                                                                <Col><strong style={{ color: "#C9461C" }}>{data?.reviewedBy || 'N/A'}</strong>  |  {data?.reviewedOn || 'N/A'}</Col>
                                                            </Row>
                                                            <br />
                                                            <Row>
                                                                <Col style={{ fontSize: 12 }}>
                                                                    {data?.remark || data?.reviewerComment}
                                                                </Col>
                                                            </Row>
                                                            <br />
                                                        </>
                                                }
                                                </>)
                                            :
                                            <>
                                                <Row>
                                                    <Col style={{ textAlign: "right", fontSize: 19, cursor: "pointer" }} onClick={() => onClose(false)}>
                                                        <strong>x</strong>
                                                    </Col>
                                                </Row>
                                            <Row className="text-center">
                                                <div style={{ margin: "0 auto" }}>Data not well formatted; kindly relaunch modal.</div>
                                            </Row>
                                            </>
                                        }
                                    </>
                                )
                            }
                        </>
                    )
                }
            </ModalBody>
        </Modal>
    );
};

export default DisbursementModal;
